export default __webpack_public_path__ + "static/media/nuReality_logo_w.acd0d39f.svg";